import apolloClient from '../../../../../graphql'
import {ITEM_RESPONSES} from '../../../../../graphql/queries/itemResponse'

/**
 * Re-reads the everplan's item responses into the Apollo cache after a life
 * story DELETE commits: the vault response group (PDF, recordings) is removed
 * server-side by the cascade, but nothing else refreshes the cache, so the
 * category page would keep showing the deleted record until a full reload
 * (TK-2983 AC 6.8).
 *
 * Called from the deferred `performDelete` — long after the scheduling
 * component unmounted — so it goes through the client directly rather than a
 * hook-bound refetch. Failures are swallowed: the cache is merely stale, and
 * the next natural fetch straightens it out.
 */
const refreshVaultItemResponses = everplanId =>
  apolloClient.query({
    query: ITEM_RESPONSES,
    variables: {everplanId: parseInt(everplanId, 10)},
    fetchPolicy: 'network-only'
  }).catch(() => {})

export default refreshVaultItemResponses
